<template>
  <ul class="tab-view-info">
    <li>
      <span>项目</span><span>:</span
      ><span style="font-weight: 500">{{
        goddess.goddessInfoRes.type | infoFilter
      }}</span>
    </li>
    <li>
      <span>费用</span><span>:</span
      ><span style="color:rgba(255, 117, 0, 1);">{{
        goddess.goddessInfoRes.price
      }}</span>
    </li>
    <li>
      <span>职业</span><span>:</span
      ><span>{{ goddess.goddessInfoRes.job | infoFilter }}</span>
    </li>
    <li>
      <span>类型</span><span>:</span
      ><span>{{ goddess.goddessInfoRes.employer | infoFilter }}</span>
    </li>
    <li>
      <span>年龄</span><span>:</span
      ><span>{{ goddess.goddessInfoRes.age | infoFilter }}岁</span>
    </li>
    <li>
      <span>身高</span><span>:</span
      ><span>{{ goddess.goddessInfoRes.height | infoFilter }}CM</span>
    </li>
    <li>
      <span>胸围</span><span>:</span
      ><span>{{ goddess.goddessInfoRes.bust | infoFilter }}</span>
    </li>
  </ul>
</template>
<script>
export default {
  name: "InfoTabView",
  props: {
    goddess: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  filters: {
    infoFilter(value) {
      return value ? value : "未知";
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-view-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  li {
    margin: 8px 0;
    span:nth-child(2) {
      display: inline-block;
      margin: 0 10px 0 5px;
    }
  }
}
</style>
